import { motion } from "framer-motion";

const FooterContent = () => {
    return (
        <section className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background px-6">

            {/* Background Glow */}
            <div className="absolute inset-0 -z-10">
                <div className="absolute left-1/2 top-1/2 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand/20 blur-3xl" />
            </div>

            {/* Content */}
            <motion.div
                initial={{ opacity: 0, y: 35 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                    duration: 0.7,
                    ease: [0.22, 1, 0.36, 1],
                }}
                className="text-center"
            >
                {/* Badge */}
                <span className="inline-flex items-center rounded-full border border-brand/30 bg-brand/10 px-4 py-1 text-xs font-semibold uppercase tracking-[0.25em] text-brand backdrop-blur">
                    Under Development
                </span>

                {/* Main Heading */}
                <h1 className="mt-6 text-balance font-sans text-4xl font-bold leading-tight text-foreground sm:text-5xl lg:text-6xl">
                    Coming Soon...
                </h1>

                {/* Description */}
                <p className="mx-auto mt-5 max-w-xl text-sm leading-7 text-foreground/70 sm:text-base md:text-lg">
                    We’re actively refining this section to deliver a better experience.
                    The website is live, and additional features and content will be available soon.
                </p>

                {/* Animated Loader */}
                <div className="mt-10 flex items-center justify-center gap-2">
                    <span className="h-3 w-3 animate-bounce rounded-full bg-brand [animation-delay:-0.3s]" />
                    <span className="h-3 w-3 animate-bounce rounded-full bg-brand [animation-delay:-0.15s]" />
                    <span className="h-3 w-3 animate-bounce rounded-full bg-brand" />
                </div>
            </motion.div>
        </section>
    );
};

export default FooterContent;